module.exports = __webpack_public_path__ + "static/baked_madeline-0736469022124a329cb7daf06e56ea80.jpg";